import { messageCenterActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import { MCCategoryIds } from '_constants'

const initialState = {
    selectedCategory: MCCategoryIds.NOTES_REQUIRING_APPROVAL
};


export const reducer = createReducer(initialState, {
    [messageCenterActions.categoryChange]: (state, action) => {
        state.selectedCategory = action.payload;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        if (action.payload.ui.messageCenter && action.payload.ui.messageCenter.selectedCategory) {
            state.selectedCategory = action.payload.ui.messageCenter.selectedCategory;
        }
    },
})


